import { ErrorResolution } from '../state/ErrorResolution';
export function createErrorResolution(errorHandler, params) {
  const {
    commonErrorsMapState,
    onlineManager
  } = errorHandler;
  const {
    errorAccessor,
    errorCodesMap
  } = params;
  const errorResolution = new ErrorResolution({
    errorAccessor,
    errorCodesMap,
    commonErrorsMapState,
    onlineManager
  });
  errorResolution.resolve();
  return errorResolution;
}
//# sourceMappingURL=createErrorResolution.js.map